import { Outlet } from "react-router-dom"

import { AppTopBar } from "./AppTopBar"

export function AppShell() {
  return (
    <div className="flex h-dvh flex-col overflow-hidden print:h-auto print:overflow-visible">
      <AppTopBar />
      <div className="flex h-full min-h-0 flex-1 flex-col overflow-hidden print:h-auto print:overflow-visible">
        <Outlet />
      </div>
    </div>
  )
}
